<template>
  <div class="criteres">
    <a href="" class="critere" @click.prevent="deselect(tag)" v-for="(tag, index) in selection">{{ tag.label }}</a>
    <a v-if="selection.length > 0" href="" class="delete" @click.prevent="reset()">Effacer tous les filtres</a>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import store from '../store';

export default {
  name: 'ponroy-filter-group',
  store,
  computed: {
    ...mapGetters('facetedFilter', [
      'selection',
    ])
  },
  methods: {
    ...mapActions('facetedFilter', [
        'changeFilterCheckbox',
        'reset'
    ]),
    deselect(tag) {
      this.changeFilterCheckbox({...tag, selected: false});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/FilterTags.vue